/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult2,
  NotFoundErrorResult2,
  ResultOfAccessResponseViewModel,
  ValidationErrorResult2,
} from '../models';
import {
    ErrorResult2FromJSON,
    ErrorResult2ToJSON,
    NotFoundErrorResult2FromJSON,
    NotFoundErrorResult2ToJSON,
    ResultOfAccessResponseViewModelFromJSON,
    ResultOfAccessResponseViewModelToJSON,
    ValidationErrorResult2FromJSON,
    ValidationErrorResult2ToJSON,
} from '../models';

/**
 * 
 */
export class SecurityApi extends runtime.BaseAPI {

    /**
     * Gets access information for the client
     */
    async securityGetAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAccessResponseViewModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/security/access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAccessResponseViewModelFromJSON(jsonValue));
    }

    /**
     * Gets access information for the client
     */
    async securityGetAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAccessResponseViewModel> {
        const response = await this.securityGetAccessRaw(initOverrides);
        return await response.value();
    }

}
